module.exports = __webpack_public_path__ + "static/marcel_bednarz-9ab48a64680598914d3458969fda4ef0.png";